;(function() {
  'use strict'

  angular.module('core.filters').filter('highlightHashtags', highlightHashtags)

  // --------------------

  /* @ngInject */
  function highlightHashtags() {
    return function(string) {
      if (!string) {
        return
      }
      var matcher = /(^|\s)#([^ ]*)/g
      var hashtags = string.match(matcher)
      // remove spaces and wrap in highlight class
      _.each(hashtags, function(tag) {
        tag = tag.replace(' ', '')
        string = string.replace(tag, '<span class="hashtag">' + tag + '</span>')
      })
      return string
    }
  }
})()
